'use client'

import React, { useEffect } from 'react';
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link, useParams } from 'react-router-dom';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
import { useDispatch, useSelector } from 'react-redux';
import { listSlider } from '../../actions/sliderAction';
// import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';


function SliderBannerShowData () {

{/*
const getConfigurableProps = () => ({
    showArrows: boolean('showArrows', true, tooglesGroupId),
    showStatus: boolean('showStatus', true, tooglesGroupId),
    showIndicators: boolean('showIndicators', true, tooglesGroupId),
    infiniteLoop: boolean('infiniteLoop', true, tooglesGroupId),
    showThumbs: boolean('showThumbs', true, tooglesGroupId),
    useKeyboardArrows: boolean('useKeyboardArrows', true, tooglesGroupId),
    autoPlay: boolean('autoPlay', true, tooglesGroupId),
    stopOnHover: boolean('stopOnHover', true, tooglesGroupId),
    swipeable: boolean('swipeable', true, tooglesGroupId),
    dynamicHeight: boolean('dynamicHeight', true, tooglesGroupId),
    emulateTouch: boolean('emulateTouch', true, tooglesGroupId),
    autoFocus: boolean('autoFocus', false, tooglesGroupId),
    thumbWidth: number('thumbWidth', 100, {}, valuesGroupId),
    selectedItem: number('selectedItem', 0, {}, valuesGroupId),
    interval: number('interval', 2000, {}, valuesGroupId),
    transitionTime: number('transitionTime', 500, {}, valuesGroupId),
    swipeScrollTolerance: number('swipeScrollTolerance', 5, {}, valuesGroupId),
    ariaLabel: text('ariaLabel', undefined),
});
*/}

const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };

  
    const dispatch = useDispatch();
    const params = useParams();

  const sliderList = useSelector((state)=>state.sliderList);
  const {error,loading,slider} =sliderList;
  


    var FLagCheck = false;
    var slider_data = null;

    function SlideImages() {
      try{
        slider_data = slider.result;
        FLagCheck = true;
      }catch (error) {
        FLagCheck = false;
      }
    }



 useEffect(() => {
    dispatch(listSlider());
    SlideImages();
  }, [dispatch,SlideImages(),]);


  
    return (
<>
        {/* <Carousel swipeable={false} autoPlay>
        { FLagCheck && !!slider.result &&  slider.result.map((item, index) => {
        return (
                <div>
                    <img  
  loading="lazy"  // Lazy loading added here
src={`${item.img}`} />
                   {/* <p className="legend">Legend 1</p>*/}
                {/* </div>

                 )}
        )}
            </Carousel> */} 


<Swiper
    
    spaceBetween={20}
    autoplay={{
      delay: 5000,
      disableOnInteraction: false,
    }}
    
    
    slidesPerView={1}
    onAutoplayTimeLeft={onAutoplayTimeLeft}
    loop={true}
  >
    
    
    { FLagCheck && !!slider.result &&  slider.result.map((item, index) => {
        return (
//     <SwiperSlide>
    
//     {/* <div className="swiper-slide">
//               <div className="testi-box">
//                 <div className="testi-box_img">
//                   <img
//                     src="assets/img/testimonial/testi_2_1.jpg"
//                     alt="Avater"
//                   />
//                   <div className="testi-box_quote">
//                     <img  
//   loading="lazy"  // Lazy loading added here
// src="assets/img/icon/quote_left_2.svg" alt="quote" />
//                   </div>
//                 </div>
//                 <div className="testi-box_content">
//                   <p className="testi-box_text">
//                     Objectively visualize error-free technology for B2B
//                     alignment. Monotonectally harness an expanded array of
//                     models via effective collaboration.
//                   </p>
//                   <div className="testi-box_review">
//                     <i className="fa-solid fa-star-sharp"></i
//                     ><i className="fa-solid fa-star-sharp"></i
//                     ><i className="fa-solid fa-star-sharp"></i
//                     ><i className="fa-solid fa-star-sharp"></i
//                     ><i className="fa-solid fa-star-sharp"></i>
//                   </div>
//                   <h3 className="box-title">David Farnandes</h3>
//                   <p className="testi-box_desig">CEO at Anaton</p>
//                 </div>
//               </div>
//             </div> */}

//       <img  
//   loading="lazy"  // Lazy loading added here
// src={`${item.img}`} style={{width:'100%', height:'550px'}} />
//           </SwiperSlide>  

<SwiperSlide>
  <img  
    loading="lazy"
    src={`${item.img}`} 
    style={{ width: '100%' }} 
    className="
      h-[140px]      // Default height for mobile (fallback)
      sm:h-[60px]   // Height for small screens (sm) and below (mobile)
      md:h-[180px]   // Height for medium screens (tablet)
      lg:h-[450px]   // Height for large screens (laptops)
      xl:h-[500px]   // Height for extra-large screens (desktops)
      2xl:h-[550px]  // Height for 2xl screens (larger desktops)
    " 
    alt="Slider Image"
  />
</SwiperSlide>

        )}
      )}
    
    
    <div className="autoplay-progress" slot="container-end">
          {/* <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg> */}
          <span ref={progressContent}></span>
        </div>
  </Swiper>
  </>
    );
};

export default SliderBannerShowData;